<template>
    <div id="colophon">
        <ul id="linklist">
            <li>
                <a :href="uitlegURL" class="button" target="_blank"
                    ><span>Uitleg</span>
                </a>
            </li>
            <li>
                <a :href="moreURL" class="button" target="_blank"
                    ><span>Meer</span>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "ColophonBlock",
    props: {
        moreURL: String,
        uitlegURL: String,
    },
};
</script>
<style>
#colophon {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    background-color: rgba(255, 255, 255, 1);
    padding-top: 14px;
    padding-bottom: 14px;
}
ul {
    padding: 0;
    margin: 0;
}
ul#linklist {
    list-style: none;
    display: flex;
    gap: 2em;
    justify-content: center;
    margin-bottom: 0;
}
ul#linklist li {
    display: inline;
    font-size: 16px;
}

li a.button {
    display: inline-flex;
    background-color: #c4e5f7;
    border-color: #1298e0;
    padding: 12px 20px;
}
li a.button:hover {
    border-color: #0a140f;
}
a {
    text-decoration: none;
    color: #1298e0;
    font-family: "icon";
    font-size: 16px;
    display: inline-flex;
    gap: 1rem;
}
span {
    font-family: "Inter";
    color: #1298e0;
}
a:hover,
span:hover {
    color: #0a140f;
}

@media (max-width: 750px) {
    #colophon {
        background-color: rgba(255, 255, 255, 0.7);
    }
}
</style>
